import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Descriptions, Select, Button, message, Spin, Card, Space } from 'antd';
import axios from 'axios';

const { Option } = Select;
const apiUrl = process.env.REACT_APP_API_BASE_URL;

const AppointmentDetails = ({ onStatusUpdate }) => {
  const [appointment, setAppointment] = useState(null);
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAppointment = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/appointments/${id}`);
        setAppointment(response.data);
        setStatus(response.data.status);
      } catch (error) {
        console.error('Randevu detayları alınırken hata:', error);
        message.error('Randevu detayları alınamadı.');
      } finally {
        setLoading(false);
      }
    };
    fetchAppointment();
  }, [id]);

  const handleStatusChange = async () => {
    try {
      await axios.put(`${apiUrl}/api/appointments/${id}`, { status });
      message.success('Randevu durumu güncellendi.');
      onStatusUpdate(); // Durum güncellendikten sonra admin sayfasındaki bildirimleri yenile
    } catch (error) {
      console.error('Durum güncellenirken hata:', error);
      message.error('Durum güncellenemedi.');
    }
  };

  // Telefon numarasını doğru formatta oluşturma
  const whatsappLink = (phone, message) => {
    // Başındaki sıfırı kaldır ve +90 ekle
    const formattedPhone = phone.replace(/\D/g, ''); // Sayısal olmayan karakterleri kaldır
    const finalPhone = formattedPhone.startsWith('0') ? `+90${formattedPhone.slice(1)}` : `+${formattedPhone}`;
    return `https://wa.me/${finalPhone}?text=${encodeURIComponent(message)}`;
  };

  const generateMessage = (type, appointment) => {
    const { fullName, date, time } = appointment;
    const base = `Merhaba ${fullName},`;
    const location = "\n📍 Ofis Konumu: https://maps.app.goo.gl/UGSht97n6bu4vbd46";

    if (type === 'approved') {
      return `${base}\n\nRandevunuz ${date} tarihinde, saat ${time}'de başarıyla ONAYLANMIŞTIR. Lütfen zamanında hazır olun.${location}\n\nİyi günler dileriz.
        \n\nAli Arda Gül Hukuk Bürosu`;
    } else {
      return `${base}\n\nÜzgünüz, ${date} tarihinde saat ${time} için oluşturduğunuz randevu talebiniz REDDEDİLMİŞTİR. Yeni bir tarih seçmek isterseniz web sitemizden tekrar başvurabilirsiniz.${location}\n\nİyi günler dileriz.\n\nAli Arda Gül Hukuk Bürosu`;
    }
  };

  if (loading) return <Spin size="large" />;

  return (
    <div style={{ maxWidth: 800, margin: 'auto' }}>
      {/* Sol üst köşe Geri Dön butonu */}
      <div style={{ marginBottom: 16 }}>
        <Button type="default" onClick={() => navigate('/admin/appointments')}>
          ← Geri Dön
        </Button>
      </div>

      <Card title="Randevu Detayları" bordered>
        <Descriptions column={1} bordered>
          <Descriptions.Item label="Ad Soyad">{appointment.fullName}</Descriptions.Item>
          <Descriptions.Item label="Telefon">{appointment.phone}</Descriptions.Item>
          <Descriptions.Item label="Email">{appointment.email}</Descriptions.Item>
          <Descriptions.Item label="Tarih">{appointment.date}</Descriptions.Item>
          <Descriptions.Item label="Saat">{appointment.time}</Descriptions.Item>
          <Descriptions.Item label="Mesaj">{appointment.message || '-'}</Descriptions.Item>
          <Descriptions.Item label="Durum">
            <Select value={status} onChange={(value) => setStatus(value)} style={{ width: 200 }}>
              <Option value="pending">Bekliyor</Option>
              <Option value="approved">Onaylı</Option>
              <Option value="rejected">Reddedildi</Option>
            </Select>
          </Descriptions.Item>
        </Descriptions>

        <Space style={{ marginTop: 24, justifyContent: 'space-between', width: '100%' }}>
          <Button type="primary" onClick={handleStatusChange}>
            Durumu Güncelle
          </Button>

          {(status === 'approved' || status === 'rejected') && appointment && (
            <a
              href={whatsappLink(appointment.phone, generateMessage(status, appointment))}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button type="default" style={{ backgroundColor: '#25D366', color: 'white' }}>
                WhatsApp ile Bildir
              </Button>
            </a>
          )}
        </Space>
      </Card>
    </div>
  );
};

export default AppointmentDetails;
